export const URL = {
  // dev
  // API_BASE_URL: "http://192.168.1.12:8000",
  // live
  API_BASE_URL: "https://backend.eventmfiesta.com",
  //API_BASE_URL: "https://eventfiestm.a2itsolution.com",

  //  eventm api's
  login_admin: "/api/admin/adminLogin",

  // dashboard api
  dashboard: "/api/admin/dashboard",


  // City Api's
  get_cities: "/api/admin/getCity",
  delete_city: "/api/admin/deleteCity",
  add_city: "/api/admin/addCity",
  update_city: "/api/admin/updateCity",

  // Area Api's
  get_areas: "/api/admin/getArea",
  delete_area: "/api/admin/deleteArea",
  add_area: "/api/admin/addArea",
  update_area: "/api/admin/updateArea",

  // Slider Api's
  get_sliders: "/api/admin/getSlider",
  create_slider: "/api/admin/createSlider",
  update_slider: "/api/admin/updateSlider",
  delete_slider: "/api/admin/deleteSlider",

  // Occasion Api's
  get_occasions: "/api/admin/getOccasion",
  create_occasion: "/api/admin/addOccasion",
  update_occasion: "/api/admin/updateOccasion",
  delete_occasion: "/api/admin/deleteOccasion",

  // Function Api's
  get_functions: "/api/admin/getFunction",
  add_function: "/api/admin/addFunction",
  update_function: "/api/admin/updateFunction",
  delete_function: "/api/admin/deleteFunction",

  // Essentials Api's
  get_essentials: "/api/admin/getFunctionEssential",
  add_essential: "/api/admin/addFunctionEssential",
  update_essential: "/api/admin/updateFunctionEssential",
  delete_essential: "/api/admin/deleteFunctionEssential",

  // Essential Types Api's
  get_essential_types: "/api/admin/getEssentialType",
  add_essential_type: "/api/admin/addEssentialType",
  update_essential_type: "/api/admin/updateEssentialType",
  delete_essential_type: "/api/admin/deleteEssentialType",

  //Delete Image
  delete_image: "/api/admin/deleteImage",

  // Order Api's
  get_orders: "/api/admin/getOrder",
  get_order_detail: "/api/admin/orderDetail",
  // create_occasion: "/api/admin/addOccasion",
  update_order: "/api/admin/updateOrder",
  delete_order: "/api/admin/deleteOrder",

  // Essential Types Api's
  get_venues: "/api/admin/getVenue",
  add_venue: "/api/admin/addVenue",
  update_venue: "/api/admin/updateVenue",
  delete_venue: "/api/admin/deleteVenue",
  delete_venue_attachment: "/api/admin/deleteVenueAttachement",

  get_gallery: "/api/admin/getGallery",
  add_gallery: "/api/admin/addGallery",
  update_gallery: "/api/admin/updateGallery",
  delete_gallery: "/api/admin/deleteGallery",

  get_youtube: "/api/admin/getVideos",
  add_youtube: "/api/admin/addVideo",
  update_youtube: "/api/admin/updateVideo",
  delete_youtube: "/api/admin/deleteVideo",

  // User Api's
get_users: "/api/admin/users",

 // Booking APIs
  get_bookings: "/api/admin/getBookings",
  update_booking_status: "/api/admin/updateBookingStatus",

};
